import api from "../axiosInstance";

export async function getAllEndpointsStatus() {
  const resp = await api.get("/api/admin/management/endpoints");
  return resp.data;
}

export async function getEndpointStatus(apiKey) {
  const resp = await api.get(`/api/admin/management/endpoints/${encodeURIComponent(apiKey)}/status`);
  return resp.data;
}

export async function toggleEndpoint(apiKey) {
  const resp = await api.post(`/api/admin/management/endpoints/${encodeURIComponent(apiKey)}/toggle`);
  return resp.data;
}

export async function enableEndpoint(apiKey) {
  const resp = await api.post(`/api/admin/management/endpoints/${encodeURIComponent(apiKey)}/enable`);
  return resp.data;
}

export async function disableEndpoint(apiKey) {
  const resp = await api.post(`/api/admin/management/endpoints/${encodeURIComponent(apiKey)}/disable`);
  return resp.data;
}

export async function getDefaultHeaders() {
  const resp = await api.get("/api/admin/management/default-headers");
  return resp.data;
}

export async function getApiConfiguration() {
  const resp = await api.get("/api/admin/management/config");
  return resp.data;
}


